function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m54.233 12.248-10.485-10.485c-1.1248-1.1248-2.6495-1.7622-4.2367-1.7622h-25.508c-3.3119 0.012498-5.9988 2.6995-5.9988 6.0113v51.99c0 3.3119 2.687 5.9988 5.9988 5.9988h35.993c3.3119 0 5.9988-2.687 5.9988-5.9988v-41.504c0-1.5872-0.63738-3.1244-1.7622-4.2492zm-4.7241 3.7618h-9.5106v-9.5106zm-35.506 41.992v-51.99h19.996v12.997c0 1.6622 1.3372 2.9994 2.9994 2.9994h12.997v35.993zm26.495-29.994h-3.5993c-0.54989 0-1.0498 0.29994-1.3122 0.78735-2.2496 4.1367-2.7745 5.299-3.5743 7.2111-1.7372-3.6368-0.86233-2.1621-3.5743-7.2111-0.26245-0.4874-0.77485-0.78735-1.3247-0.78735h-3.6118c-1.1623 0-1.8746 1.2498-1.2997 2.2496l5.7864 9.7481-5.7864 9.7481c-0.58738 0.9998 0.13747 2.2496 1.2997 2.2496h3.6118c0.54989 0 1.0498-0.29994 1.3122-0.78735 2.712-4.999 2.8744-5.6239 3.5743-7.2111 1.8621 3.7743 0.73736 1.9871 3.5743 7.2111 0.26245 0.4874 0.77485 0.78735 1.3247 0.78735h3.5993c1.1623 0 1.8746-1.2498 1.2997-2.2496l-5.7989-9.7481c0.08748-0.13747 3.7868-6.3113 5.7864-9.7481 0.58738-0.9998-0.13747-2.2496-1.2872-2.2496z",
    fill: "currentColor",
    style: {
      strokeWidth: 0.12498
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileExcel);
export default __webpack_public_path__ + "static/media/file-excel.868267c8.svg";
export { ForwardRef as ReactComponent };